import { graphql } from '@/gql/graphql';

export default graphql(/* GraphQL */ `
  fragment DeleteMessageReactionByPkOptimistic on message_reaction {
    __typename
    id
    content
    message {
      id
      reaction_count
      your_reactions {
        id
      }
    }
  }
`);
